export const SET_BUSINESS_LISTINGS_DATA = 'SET_BUSINESS_LISTINGS_DATA';